import { z } from 'zod';

export const loginRequestSchema = z.object({
  email: z.string(),
  password: z.string(),
});

export const loginResponseSchema = z.object({
  accessToken: z.string(),
  accessTokenExpireMinutes: z.number(),
  refreshToken: z.string(),
  refreshTokenExpireMinutes: z.number(),
});

export type LoginRequest = z.infer<typeof loginRequestSchema>;
export type LoginResponse = z.infer<typeof loginResponseSchema>;

export const reportAuthenticationsResponseSchema = z.object({
  accessToken: z.string(),
  accessTokenExpireMinutes: z.number(),
});

export type ReportAuthenticationsResponse = z.infer<typeof reportAuthenticationsResponseSchema>;

